import { FetchApiResponse, FilterMetadata } from "redux/types";

export enum DashboardReduxTypes {
  FETCH_DASHBOARD_OPERATIONS_SUMMARY = "@@dashboard/FETCH_DASHBOARD_OPERATIONS_SUMMARY",
  FETCH_DASHBOARD_OPERATIONS_SUMMARY_SUCCESS = "@@dashboard/FETCH_DASHBOARD_OPERATIONS_SUMMARY_SUCCESS",
  FETCH_DASHBOARD_OPERATIONS_SUMMARY_ERROR = "@@dashboard/FETCH_DASHBOARD_OPERATIONS_SUMMARY_ERROR",

  FETCH_RENEWAL_AND_EXPIRY = "@@dashboard/FETCH_RENEWAL_AND_EXPIRY",
  FETCH_RENEWAL_AND_EXPIRY_SUCCESS = "@@dashboard/FETCH_RENEWAL_AND_EXPIRY_SUCCESS",
  FETCH_RENEWAL_AND_EXPIRY_ERROR = "@@dashboard/FETCH_RENEWAL_AND_EXPIRY_ERROR",

  FETCH_TXNS_BY_USER = "@@dashboard/FETCH_TXNS_BY_USER",
  FETCH_TXNS_BY_USER_SUCCESS = "@@dashboard/FETCH_TXNS_BY_USER_SUCCESS",
  FETCH_TXNS_BY_USER_ERROR = "@@dashboard/FETCH_TXNS_BY_USER_ERROR",

  FETCH_PROGRAM_PERFORMANCE = "@@dashboard/FETCH_PROGRAM_PERFORMANCE",
  FETCH_PROGRAM_PERFORMANCE_SUCCESS = "@@dashboard/FETCH_PROGRAM_PERFORMANCE_SUCCESS",
  FETCH_PROGRAM_PERFORMANCE_ERROR = "@@dashboard/FETCH_PROGRAM_PERFORMANCE_ERROR",

  FETCH_PRODUCT_MIX = "@@dashboard/FETCH_PRODUCT_MIX",
  FETCH_PRODUCT_MIX_SUCCESS = "@@dashboard/FETCH_PRODUCT_MIX_SUCCESS",
  FETCH_PRODUCT_MIX_ERROR = "@@dashboard/FETCH_PRODUCT_MIX_ERROR",

  FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY = "@@dashboard/FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY",
  FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_SUCCESS = "@@dashboard/FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_SUCCESS",
  FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_ERROR = "@@dashboard/FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_ERROR",

  FETCH_AGEING_BUCKETS = "@@dashboard/FETCH_AGEING_BUCKETS",
  FETCH_AGEING_BUCKETS_SUCCESS = "@@dashboard/FETCH_AGEING_BUCKETS_SUCCESS",
  FETCH_AGEING_BUCKETS_ERROR = "@@dashboard/FETCH_AGEING_BUCKETS_ERROR",

  FETCH_DISBURSEMENT_BY_FY_GRAPH = "@@dashboard/FETCH_DISBURSEMENT_BY_FY_GRAPH",
  FETCH_DISBURSEMENT_BY_FY_GRAPH_SUCCESS = "@@dashboard/FETCH_DISBURSEMENT_BY_FY_GRAPH_SUCCESS",
  FETCH_DISBURSEMENT_BY_FY_GRAPH_ERROR = "@@dashboard/FETCH_DISBURSEMENT_BY_FY_GRAPH_ERROR",

  RESET = "@@dashboard/RESET"
}

export type DashboardActionDispatch = {
  type:
    | DashboardReduxTypes.FETCH_DASHBOARD_OPERATIONS_SUMMARY
    | DashboardReduxTypes.FETCH_RENEWAL_AND_EXPIRY
    | DashboardReduxTypes.FETCH_TXNS_BY_USER
    | DashboardReduxTypes.FETCH_PROGRAM_PERFORMANCE
    | DashboardReduxTypes.FETCH_PRODUCT_MIX
    | DashboardReduxTypes.FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY
    | DashboardReduxTypes.FETCH_AGEING_BUCKETS
    | DashboardReduxTypes.FETCH_DISBURSEMENT_BY_FY_GRAPH
    | DashboardReduxTypes.RESET;
  payload: any;
};

export type DashboardReducerDispatch = {
  type:
    | DashboardReduxTypes.FETCH_DASHBOARD_OPERATIONS_SUMMARY
    | DashboardReduxTypes.FETCH_DASHBOARD_OPERATIONS_SUMMARY_SUCCESS
    | DashboardReduxTypes.FETCH_DASHBOARD_OPERATIONS_SUMMARY_ERROR
    | DashboardReduxTypes.FETCH_RENEWAL_AND_EXPIRY
    | DashboardReduxTypes.FETCH_RENEWAL_AND_EXPIRY_SUCCESS
    | DashboardReduxTypes.FETCH_RENEWAL_AND_EXPIRY_ERROR
    | DashboardReduxTypes.FETCH_TXNS_BY_USER
    | DashboardReduxTypes.FETCH_TXNS_BY_USER_SUCCESS
    | DashboardReduxTypes.FETCH_TXNS_BY_USER_ERROR
    | DashboardReduxTypes.FETCH_PROGRAM_PERFORMANCE
    | DashboardReduxTypes.FETCH_PROGRAM_PERFORMANCE_SUCCESS
    | DashboardReduxTypes.FETCH_PROGRAM_PERFORMANCE_ERROR
    | DashboardReduxTypes.FETCH_PRODUCT_MIX
    | DashboardReduxTypes.FETCH_PRODUCT_MIX_SUCCESS
    | DashboardReduxTypes.FETCH_PRODUCT_MIX_ERROR
    | DashboardReduxTypes.FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY
    | DashboardReduxTypes.FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_SUCCESS
    | DashboardReduxTypes.FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_ERROR
    | DashboardReduxTypes.FETCH_AGEING_BUCKETS
    | DashboardReduxTypes.FETCH_AGEING_BUCKETS_SUCCESS
    | DashboardReduxTypes.FETCH_AGEING_BUCKETS_ERROR
    | DashboardReduxTypes.FETCH_DISBURSEMENT_BY_FY_GRAPH
    | DashboardReduxTypes.FETCH_DISBURSEMENT_BY_FY_GRAPH_SUCCESS
    | DashboardReduxTypes.FETCH_DISBURSEMENT_BY_FY_GRAPH_ERROR
    | DashboardReduxTypes.RESET;
  payload: {
    data?:
      | DashboardOperationsSummary
      | DashboardPortfolioAnalyticsSummary
      | AgeingBuckets
      | DisbursementByFYGraph
      | FetchApiResponse<RenewalAndExpiryRecord>
      | DashboardListResponse<TxnsByUserRecord>
      | DashboardListResponse<ProgramPerformanceRecord>
      | DashboardListResponse<ProductMixRecord>;
    error?: string;
  };
};

export type DashboardOperationsSummary = {
  businessDate: string;
  totalCases: number;
  newCases: number;
  enhancementCases: number;
  pendingMakerCount: number;
  pendingMakerAmount: number;
  pendingCheckerCount: number;
  pendingCheckerAmount: number;
  pendingPickupCount: number;
  pendingPickupAmount: number;
  rejectCount: number;
  rejectAmount: number;
  utrPendingCount: number;
  utrPendingAmount: number;
  processedTodayCount: number;
  processedTodayAmount: number;
  repaymentTodayCount: number;
  repaymentTodayAmount: number;
};

export type DashboardOperationsSummaryReduxState = {
  loading?: boolean;
  data?: DashboardOperationsSummary | null;
  error?: string | null;
};

export type DashboardOperationsSummaryFetchRequest = {
  payload: FilterMetadata | Record<string, any>;
  type: string;
};

export type RenewalAndExpiryRecord = {
  externalId: string;
  customer: string;
  limit: number;
  utilised: number;
  utilPercentage: number;
  expiry: string;
  days: number;
  programName: string | null;
};

export type RenewalAndExpiryReduxState = {
  loading?: boolean;
  data?: FetchApiResponse<RenewalAndExpiryRecord> | null;
  error?: string | null;
};

export type RenewalAndExpiryFetchRequest = {
  payload: FilterMetadata;
  type: string;
};

export type TxnsByUserRecord = {
  userName: string;
  totalPickedRecords: number;
  totalFundingAmount: number;
  totalApprovedRecords: number;
  totalApprovedAmount: number;
  totalRejectedRecords: number;
  totalRejectedAmount: number;
  roles: string[];
  label?: string;
};

export type TxnsByUserReduxState = {
  loading?: boolean;
  data?: DashboardListResponse<TxnsByUserRecord> | null;
  error?: string | null;
};

export type TxnsByUserFetchRequest = {
  payload: FilterMetadata;
  type: string;
};

export type DashboardHealthStatus = "HEALTHY" | "WATCH" | "STRESS" | string;

export type ProgramPerformanceRecord = {
  programId: string;
  program: string;
  productType: string;
  label?: string;
  limit: number;
  outstanding: number;
  utilPercentage: number;
  customerRelationId: string | null;
  businessDate: string | null;
  overDuePercentage: number;
  avgDPD: number;
  ctpty: number;
  healthy: DashboardHealthStatus;
};

export type DashboardListResponse<T> = FetchApiResponse<T> & {
  total?: T[];
};

export type ProgramPerformanceReduxState = {
  loading?: boolean;
  data?: DashboardListResponse<ProgramPerformanceRecord> | null;
  error?: string | null;
};

export type ProgramPerformanceFetchRequest = {
  payload: FilterMetadata;
  type: string;
};

export type ProductMixRecord = {
  externalId?: string;
  productType: string;
  label?: string;
  programs: number;
  ctpty: number;
  sanctioned: number;
  utilPercentage: number;
  utilised: number;
  available: number;
  overDue: number;
  overDuePercentage: number;
  npa: number;
  disbMTD: number;
  disbYTD: number;
  healthy: DashboardHealthStatus;
};

export type ProductMixReduxState = {
  loading?: boolean;
  data?: DashboardListResponse<ProductMixRecord> | null;
  error?: string | null;
};

export type ProductMixFetchRequest = {
  payload: FilterMetadata;
  type: string;
};

export type DashboardPortfolioAnalyticsSummary = {
  totalSanctionedLimit: number;
  totalPrograms: number;
  totalAnchors: number;
  addedMtd: number;
  totalOutstanding: number;
  totalAvailable: number;
  peakMtd: number;
  utilisationPercentage: number;
  previousMonthUtilisationPercentage: number;
  dormantLimits: number;
  activeCounterparties: number;
  onboardedMtd: number;
  disbursementMtd: number;
  disbursementYtd: number;
  dailyRunRate: number;
  overDueTotal: number;
  osPercentage: number;
  overDueCustomers: number;
  overDueInvoices: number;
  npa: number;
  gnpaPercentage: number;
  npaCustomers: number;
  collectionEfficiencyMTD: number;
  paymentRatePercentage: number;
  avgROIPercentage: number;
};

export type DashboardPortfolioAnalyticsSummaryReduxState = {
  loading?: boolean;
  data?: DashboardPortfolioAnalyticsSummary | null;
  error?: string | null;
};

export type DashboardPortfolioAnalyticsSummaryFetchRequest = {
  payload: FilterMetadata | Record<string, any>;
  type: string;
};

export type AgeingBucketItem = {
  bucket: string;
  label: string;
  customers: number;
  invoices: number;
  amount: number;
  pctOfBook: number;
  pctOfOverdue: number;
};

export type AgeingBuckets = {
  businessDate: string;
  items: AgeingBucketItem[];
  records?: AgeingBucketItem[];
  total?: AgeingBucketItem[];
};

export type AgeingBucketsReduxState = {
  loading?: boolean;
  data?: AgeingBuckets | null;
  error?: string | null;
};

export type AgeingBucketsFetchRequest = {
  payload: FilterMetadata | Record<string, any>;
  type: string;
};

export type DisbursementByFYGraphItem = {
  monthNo: number;
  month: string;
  disbursementAmount: number;
};

export type DisbursementByFYGraph = {
  businessDate: string;
  items: DisbursementByFYGraphItem[];
};

export type DisbursementByFYGraphReduxState = {
  loading?: boolean;
  data?: DisbursementByFYGraph | null;
  error?: string | null;
};

export type DisbursementByFYGraphFetchRequest = {
  payload: FilterMetadata | Record<string, any>;
  type: string;
};
